import { render, staticRenderFns } from "./SignToggleBtn.vue?vue&type=template&id=0180fa9b&scoped=true&"
import script from "./SignToggleBtn.vue?vue&type=script&lang=js&"
export * from "./SignToggleBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180fa9b",
  null
  
)

export default component.exports